enum MouseEvents {
  POINTER_UP = "pointerup",
  MOUSE_UP = "mouseup",
  BLUR = "blur",
}

export default MouseEvents;
